import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable()
export class InternationalizationService {
  public currentLanguage = new BehaviorSubject('en')

  isEng() {
    return true
  }
}
